<div  
    class="remove-button-wrapper"
    (click)="onClick()">
    <mat-icon inline class="x-icon remove-icon">close</mat-icon> 
    <p class="text-xs self-center">Remove</p>
</div>
